import { SET_REPORT_DURATION } from './actionTypes';

const setReportDuration = (timing, reportPresetName) => ({
    type: SET_REPORT_DURATION,
    payload: { timing, reportPresetName },
});

export default setReportDuration;
